import { render, staticRenderFns } from "./Facturar.vue?vue&type=template&id=4a50bbcc&scoped=true&"
import script from "./Facturar.vue?vue&type=script&lang=js&"
export * from "./Facturar.vue?vue&type=script&lang=js&"
import style0 from "./Facturar.vue?vue&type=style&index=0&id=4a50bbcc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a50bbcc",
  null
  
)

export default component.exports